import { CREATE_CASE_CALLBACKS_FLOW_TYPE } from '@/constants/amend/createCaseCallbacks'
import { DOMAIN } from '@/utils/general/environment'

export type BuildCreateCaseContext = {
  caseFlowType: string
  isFlexiFlyIntlBooking: boolean
  getSourceType: () => string
}

export function buildCreateCaseCallbacksPayload(
  reqObj: Record<string, unknown>,
  ctx: BuildCreateCaseContext
): Record<string, unknown> {
  const payload: Record<string, unknown> = { ...reqObj }
  const domain =
    typeof window !== 'undefined' ? window.location.hostname : new URL(DOMAIN.QA).hostname
  if (!payload.type) {
    payload.type = CREATE_CASE_CALLBACKS_FLOW_TYPE.CALLBACK_FULFILLMENT
    if (domain.indexOf('com') === -1 || ctx.isFlexiFlyIntlBooking) {
      payload.type = CREATE_CASE_CALLBACKS_FLOW_TYPE.CALLBACK_OUTBOUND
    }
    if (
      ctx.caseFlowType === CREATE_CASE_CALLBACKS_FLOW_TYPE.CALLBACK_FULFILLMENT ||
      ctx.caseFlowType === CREATE_CASE_CALLBACKS_FLOW_TYPE.COMPLAINT
    ) {
      payload.type = CREATE_CASE_CALLBACKS_FLOW_TYPE.FULFILLMENT
    }
    if (
      ((domain.indexOf('com') === -1 || ctx.isFlexiFlyIntlBooking) &&
        (ctx.caseFlowType === CREATE_CASE_CALLBACKS_FLOW_TYPE.CALLBACK_OUTBOUND ||
          ctx.caseFlowType === CREATE_CASE_CALLBACKS_FLOW_TYPE.COMPLAINT)) ||
      ctx.caseFlowType === CREATE_CASE_CALLBACKS_FLOW_TYPE.SOS
    ) {
      payload.type = CREATE_CASE_CALLBACKS_FLOW_TYPE.OUTBOUND
    }
  }
  payload.sourceType = ctx.getSourceType()
  return payload
}
